import React from 'react';
import { Form as ReduxForm } from 'redux-form';
import { Row, Col } from 'antd';

import Form from '../../../elements/Form';
import Loading from '../../../elements/Loading';

import { isRequired, isOneOfManyRequired, charLessThan } from '../../../core/utils/validators';
import { mapToOptions } from '../../../core/utils/helpers';

const { STATUS_OPTIONS, SUPPLIER_TYPE_OPTIONS } = require('../../../core/utils/options').default;

const FormGroup = Form.Group;
const formTypes = Form.formTypes;

export default function () {
    const formLeftConfig = [
        { type: formTypes.TEXT, name: 'title', label: 'Name', validate: [isRequired] },
        { type: formTypes.TEXT, name: 'telephone', label: 'Phone', validate: [value => charLessThan(value, 15)] },
        { type: formTypes.EMAIL, name: 'email', label: 'Email' },
        { type: formTypes.CHECKBOX, name: 'type', options: SUPPLIER_TYPE_OPTIONS, validate: [isOneOfManyRequired] },
        { type: formTypes.SELECT, name: 'is_active', label: 'Status', options: STATUS_OPTIONS },
    ];
    const formRightConfig = [
        { type: formTypes.MULTISELECT, name: 'product_category_ids', label: 'Associated Product Categories', options: mapToOptions(this.props.productCategories) }
    ];

    return (
        <div className="container">
            <div className="section">
                <ReduxForm onSubmit={this.props.handleSubmit(this.handleUpdateSupplierSubmit)} className="ant-form ant-form-vertical">
                    <div className="section__header">
                        <h3 className="h-4">Supplier & Manufacturer Details</h3>
                    </div>
                    <div className="section-white">
                        {!this.props.isFetching ?
                            <Row gutter={80} type="flex" justify="center">
                                <Col span={24} md={12} lg={10}>
                                    <FormGroup config={formLeftConfig} />
                                </Col>
                                <Col span={24} md={12} lg={10}>
                                    <FormGroup config={formRightConfig} />
                                </Col>
                            </Row>
                            : <Loading className="flex-center-middle" style={{ minHeight: 370 }} />}
                    </div>
                </ReduxForm>
            </div>
        </div>
    );
}
